module.exports = __webpack_public_path__ + "img/funnel_1.f7a0ca75.png";